import React, { useEffect } from 'react';
import { Progress } from 'web-library';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import CandidateProfileForm from './CandidateProfileForm';
import { useCandidateProfileDetails } from '../logic/useCandidateProfileDetails';
import { selectFormEditMode } from '../../../store/formSlice';
import { usePostAuditViewProfile } from '../../../api-refactored/user/usePostAuditViewProfile';
import { CreateCandidateFormLocationState } from '../logic/useCreateCandidateForm';

const CandidateProfileDetails = () => {
  const location = useLocation<CreateCandidateFormLocationState>();

  const isRedirectFromMyInfo = location?.state?.redirectFromMyInfo;

  const {
    formDefaultValues,
    formDefaultValuesViewDetails,
    isEditProfileWindowOpen,
    isRequestProfileAmendmentOpen,
    noRegistration,
    hasPendingAmendmentRequest,
    refetchCandidateProfileDetails,
    updateCandidateDetails,
    updateCandidateDetailsApiStatus,
    updateCandidateDetailsError,
  } = useCandidateProfileDetails({ state: location?.state });

  const viewProfile = usePostAuditViewProfile();

  const editMode = useSelector(selectFormEditMode);

  useEffect(() => {
    viewProfile.mutate();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);


  if (!formDefaultValues) {
    return <Progress color="secondary" />;
  }

  const disabledInputsWithNoRegistration = {
    name: isRedirectFromMyInfo,
    IdType: true,
    NricFin: true,
    hanyupinyinName: false,
    gender: isRedirectFromMyInfo,
    dateOfBirth: isRedirectFromMyInfo,
    email: false,
    race: isRedirectFromMyInfo,
    secondaryRace: isRedirectFromMyInfo,
    nationality: isRedirectFromMyInfo,
    prStatus: isRedirectFromMyInfo,
    nationalityIssueDate: true,
    citizenship: true,
    occupation: isRedirectFromMyInfo,
    school: true,

    // addresses
    houseOrBlkNo: isRedirectFromMyInfo,
    streetName: isRedirectFromMyInfo,
    building: isRedirectFromMyInfo,
    floor: isRedirectFromMyInfo,
    unit: isRedirectFromMyInfo,
    postalCode: isRedirectFromMyInfo,
    foreignAddress1: false,
    foreignAddress2: false,
    foreignAddress3: false,
    preferredAddress: false,

    // contact numbers
    telephoneCountryCode: false,
    telephoneContactNumber: false,
    mobileCountryCode: false,
    mobileContactNumber: false,
    preferredTelephoneOrMobile: false,

    // next of kin
    nextOfKinName: false,
    nextOfKinCountryCode: false,
    nextOfKinContactNumber: false,
    nextOfKinRelationshipToCandidate: false,
  };

  const disabledInputsWithoutApproval = {
    name: true,
    IdType: true,
    NricFin: true,
    hanyupinyinName: false,
    gender: isRedirectFromMyInfo,
    dateOfBirth: isRedirectFromMyInfo || true,
    email: false,
    race: isRedirectFromMyInfo,
    secondaryRace: false,
    nationality: false,
    prStatus: true,
    nationalityIssueDate: true,
    citizenship: true,
    occupation: true,
    school: true,

    // addresses
    houseOrBlkNo: isRedirectFromMyInfo,
    streetName: isRedirectFromMyInfo,
    building: isRedirectFromMyInfo,
    floor: isRedirectFromMyInfo,
    unit: isRedirectFromMyInfo,
    postalCode: isRedirectFromMyInfo,
    foreignAddress1: isRedirectFromMyInfo,
    foreignAddress2: isRedirectFromMyInfo,
    foreignAddress3: isRedirectFromMyInfo,
    preferredAddress: isRedirectFromMyInfo,

    // contact numbers
    telephoneCountryCode: isRedirectFromMyInfo,
    telephoneContactNumber: isRedirectFromMyInfo,
    mobileCountryCode: false,
    mobileContactNumber: false,
    preferredTelephoneOrMobile: isRedirectFromMyInfo,

    // next of kin
    nextOfKinName: isRedirectFromMyInfo,
    nextOfKinCountryCode: isRedirectFromMyInfo,
    nextOfKinContactNumber: isRedirectFromMyInfo,
    nextOfKinRelationshipToCandidate: isRedirectFromMyInfo,
  };

  return (
    <CandidateProfileForm
      isHideEditButton={!(noRegistration || isEditProfileWindowOpen)}
      // [SEABMIEB-1129] Only certain fields are editable
      isDisableInputs={
        noRegistration ? disabledInputsWithNoRegistration : disabledInputsWithoutApproval
      }
      isDisableValidationForDisabledInputs
      defaultEditState={editMode}
      formDefaultValues={formDefaultValues}
      formDefaultValuesViewDetails={formDefaultValuesViewDetails}
      onCallHandleSubmit={(formData) => updateCandidateDetails(formData)}
      ApiButtonStatus={updateCandidateDetailsApiStatus}
      submitError={updateCandidateDetailsError}
      isRequestProfileAmendmentOpen={isRequestProfileAmendmentOpen}
      hasPendingAmendmentRequest={hasPendingAmendmentRequest}
      refetchCandidateProfileDetails={refetchCandidateProfileDetails}
    />
  );
};

export default CandidateProfileDetails;
